<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to acknowledge and thank the following people for their help and support in bringing this book to fruition.</p><br/>
<p style="text-align: center;">Jennifer Conner</p>
<p style="text-align: center;">Rafal Golaj</p>
<p style="text-align: center;">Clare Harris</p>
<p style="text-align: center;">Brian Masters</p>
<p style="text-align: center;">Olga Matthias</p>
<p style="text-align: center;">Rena Neville</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?34d678eb